"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "dialing-wrapper" };
var _hoisted_2 = {
    key: 0,
    id: "local",
    class: "dialing-local"
};
var _hoisted_3 = {
    key: 1,
    class: "dialing-content"
};
var _hoisted_4 = { class: "dialing-user-id" };
var _hoisted_5 = {
    key: 1,
    class: "microphone-icon-container"
};
var _hoisted_6 = { class: "dialing-info" };
var store_1 = require("../store");
var constants_1 = require("../constants");
var MicrophoneIcon_vue_1 = require("./MicrophoneIcon.vue");
var microphoneClosed_vue_1 = require("../icons/microphoneClosed.vue");
require("../style.css");
var vue_3 = require("vue");
var __1 = require("../");
var utils_1 = require("../utils");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Dialing',
    setup: function (__props) {
        (0, vue_3.onMounted)(function () {
            if (store_1.status.value === constants_1.STATUS.DIALING_C2C && store_1.callType.value === constants_1.CALL_TYPE_STRING.VIDEO) {
                __1.TUICallKitServer.startLocalView("local");
                var dialingWrapper = document.getElementsByClassName("dialing-wrapper")[0];
                dialingWrapper.style.opacity = "100%";
            }
        });
        (0, vue_3.onUnmounted)(function () {
            __1.TUICallKitServer.stopLocalView();
        });
        return function (_ctx, _cache) {
            var _a, _b;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.unref)(store_1.status) === (0, vue_2.unref)(constants_1.STATUS).DIALING_C2C && (0, vue_2.unref)(store_1.callType) === (0, vue_2.unref)(constants_1.CALL_TYPE_STRING).VIDEO)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2))
                    : (0, vue_2.createCommentVNode)("", true),
                (!(0, vue_2.unref)(utils_1.isMobile) || (0, vue_2.unref)(store_1.status) === (0, vue_2.unref)(constants_1.STATUS).BE_INVITED || (0, vue_2.unref)(store_1.status) === (0, vue_2.unref)(constants_1.STATUS).CALLING_C2C_AUDIO)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            ((0, vue_2.unref)(store_1.remoteList).length >= 1)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.remoteList)[0].userID), 1)
                                ], 64))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(store_1.status) === (0, vue_2.unref)(constants_1.STATUS).CALLING_C2C_AUDIO)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                    ((_a = (0, vue_2.unref)(store_1.remoteList)[0]) === null || _a === void 0 ? void 0 : _a.microphone)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(MicrophoneIcon_vue_1.default, {
                                            key: 0,
                                            volume: (_b = (0, vue_2.unref)(store_1.remoteList)[0]) === null || _b === void 0 ? void 0 : _b.volume
                                        }, null, 8, ["volume"]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(microphoneClosed_vue_1.default, { key: 1 }))
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(store_1.dialingInfo)), 1)
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
